<template>
    <v-dialog v-model="isOpen" max-width="800">
        <v-card>
            <v-tabs v-model="selectedTab" bg-color="primary">
                <v-tab value="tab-main">Main</v-tab>
                <v-tab value="tab-code">Code</v-tab>
                <v-tab value="tab-recipe">Recipe</v-tab>
                <v-tab value="tab-stats">Stats</v-tab>
            </v-tabs>

            <v-card-text>
                <v-tabs-window v-model="selectedTab">
                    <v-tabs-window-item value="tab-main">
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        :disabled="!isNew"
                                        v-model="localItem.itemHandle"
                                        label="Handle"
                                    />
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field
                                        disabled
                                        v-model="localItem.id"
                                        label="ID"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        disabled
                                        v-model="localItem.discordId"
                                        label="Discord ID"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        v-model="localItem.name"
                                        label="Name"
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        v-model="localItem.description"
                                        label="Description"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-select
                                        v-model="localItem.itemType"
                                        label="Type"
                                        :items="[
                                            'Material',
                                            'Consumable',
                                            'Food',
                                            'Weapon',
                                            'Equipment',
                                            'Junk',
                                        ]"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field
                                        v-model.number="localItem.weight"
                                        label="Weight"
                                        type="number"
                                        step="0.1"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        v-model.number="localItem.rarity"
                                        label="Rarity"
                                        type="number"
                                        step="1"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select
                                        v-model="localItem.itemQuality"
                                        label="Quality"
                                        :items="[
                                            'Shoddy',
                                            'Common',
                                            'Uncommon',
                                            'High Quality',
                                            'Masterwork',
                                        ]"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select
                                        v-model="localItem.visibility"
                                        label="Visibility"
                                        :items="visibilityOptions"
                                        item-title="text"
                                        item-value="value"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="4" md="4">
                                    <v-checkbox
                                        v-model="localItem.bPlaceable"
                                        label="Can be placed"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-checkbox
                                        v-model="localItem.bIsStackable"
                                        label="Stackable"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        v-if="localItem.bIsStackable"
                                        v-model.number="localItem.maxStackSize"
                                        label="Max Stack Size"
                                        type="number"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        v-model="localItem.mesh"
                                        label="Mesh"
                                    />
                                    <v-checkbox
                                        v-model="localItem.bIsContainer"
                                        label="Container"
                                    />
                                    <v-text-field
                                        disabled
                                        v-model="localItem.createdAt"
                                        label="Created At"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        v-model="localItem.icon"
                                        label="Icon"
                                    />
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                :style="{ visibility: localItem.bIsContainer ? 'visible' : 'hidden' }"
                                                v-model="localItem.containerMaxWeight"
                                                label="Max Weight"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-show="localItem.bIsContainer"
                                                v-model="localItem.containerMaxCount"
                                                label="Max Count"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-text-field
                                        disabled
                                        v-model="localItem.updatedAt"
                                        label="Updated At"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <Base64FileField
                                        v-model="localItem.IconFile"
                                        label="Upload Attachment"
                                        accept="image/png"
                                        :max-bytes="5 * 1024 * 1024"
                                        :return-only-base64="false"
                                        @error="errorMessage = $event"
                                    />
                                    <div v-if="localItem.IconFile?.base64" class="mt-2">
                                        <v-img
                                            :src="`data:${localItem.IconFile.type||'image/png'};base64,${localItem.IconFile.base64}`"
                                            max-width="160"
                                            aspect-ratio="1"
                                            cover
                                            class="rounded-lg elevation-1"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4" md="4">
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="tab-stats">
                        <v-alert
                            v-if="jsonErrorStats"
                            type="error"
                            density="compact"
                        >
                            Invalid JSON: {{ jsonErrorStats }}
                        </v-alert>
                        <v-textarea
                            rows="30"
                            v-model="localItem.itemStatistics"
                            style="
                                font-family: 'Consolas', 'Courier New',
                                    monospace;
                                font-size: 12px;
                            "
                            spellcheck="false"
                            autocorrect="off"
                            autocomplete="off"
                            @input="validateJsonStats"
                            label="Item Stats"
                        >
                        </v-textarea>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="tab-code">
                        <v-textarea
                            rows="30"
                            v-model="localItem.sourcecode"
                            style="
                                font-family: 'Consolas', 'Courier New',
                                    monospace;
                                font-size: 12px;
                            "
                            spellcheck="false"
                            autocorrect="off"
                            label="Code"
                        >
                        </v-textarea>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="tab-recipe">
                        <v-alert
                            v-if="jsonErrorCraftable"
                            type="error"
                            density="compact"
                        >
                            Invalid JSON: {{ jsonErrorCraftable }}
                        </v-alert>
                        <v-textarea
                            rows="30"
                            v-model="localItem.craftable"
                            style="
                                font-family: 'Consolas', 'Courier New',
                                    monospace;
                                font-size: 12px;
                            "
                            spellcheck="false"
                            autocorrect="off"
                            autocomplete="off"
                            @input="validateJsonCraftable"
                            label="Crafting"
                        >
                        </v-textarea>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>

            <v-card-actions>
                <span v-if="errorMessage" class="text-body-2 text-red mt-2 ml-6">{{ errorMessage }}</span>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :disabled="isBusy"
                    text
                    @click="closeDialog"
                    >Close</v-btn
                >
                <v-btn
                    color="blue-darken-1"
                    :disabled="isBusy"
                    variant="text"
                    @click="saveAndClose"
                    >Save</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import Base64FileField from "./../Base64FileField.vue";

export default {
    name: 'EditItem',
    components: { Base64FileField },
    emits: ['update:modelValue', 'request-reload'],
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    data() {

        const tempItem = this.item ?? {};

        return {
            isNew: false,
            errorMessage: '',
            selectedTab: 'tab-main',
            jsonErrorStats: null,
            jsonErrorCraftable: null,
            isBusy: false,
            localItem: {
                ...tempItem,
                itemHandle: tempItem.itemHandle ?? 'newhandle',
                IconFile: null,
            },
            visibilityOptions: [
                { text: 'None', value: 'EIV_None'},
                { text: 'Floor', value: 'EIV_Floor'},
                { text: 'Translucid', value: 'EIV_Translucid'},
                { text: 'See Through', value: 'EIV_SeeThrough'},
            ]
        };
    },
    watch: {
        item(newItem) {
            this.localItem = { ...newItem, IconFile: null };
            if (newItem?.iconData) {
                this.localItem.IconFile = {
                    base64: newItem.iconData,
                    type: 'image/png',
                    name: 'icon',
                    size: 0,
                };
            }
            this.isNew = Object.keys(newItem).length === 0;
            this.validateJsonStats();
            this.validateJsonCraftable();
        },
    },
    computed: {
        isOpen: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
    methods: {
        validateForSave() {
            this.errorMessage = '';

            if (this.localItem.itemHandle === undefined || this.localItem.itemHandle.length < 3)
                this.errorMessage = 'Invalid item handle, need at least 3 characters.';

            if (!this.validateJsonStats())
                this.errorMessage = this.jsonErrorStats;

            if (!this.validateJsonCraftable())
                this.errorMessage = this.jsonErrorCraftable;

            // Disable until we add capability to upload mesh files
            // if (!!this.localItem.bPlaceable
            //     && (!this.localItem.mesh || this.localItem.mesh.trim() === ''))
            //     this.errorMessage = 'If placeable, mesh cannot be null.'

            if (this.localItem.bIsStackable && (!this.localItem.maxStackSize || this.localItem.maxStackSize <= 1))
                this.errorMessage = 'If stackable, max stack size must be greater than 1.'

            if (this.localItem.bIsContainer && (!this.localItem.containerMaxWeight || this.localItem.containerMaxWeight <= 0))
                this.errorMessage = 'If container, max weight needs to be above zero.'

            if (this.localItem.bIsContainer && (!this.localItem.containerMaxCount || this.localItem.containerMaxCount < 1))
                this.errorMessage = 'If container, max count needs to be at least one.'

            return (this.errorMessage.length === 0);
        },
        validateJsonStats() {
            try {
                if (this.localItem.itemStatistics === undefined
                || this.localItem.itemStatistics.length === 0
                || JSON.parse(this.localItem.itemStatistics))
                {
                    this.jsonErrorStats = null;
                    return true;
                }
            }
            catch {
                this.jsonErrorStats = 'Invalid Stats,  malformed Json.';
            }
            return false;
        },
        validateJsonCraftable() {
            try {
                if (this.localItem.craftable === undefined
                || this.localItem.craftable.length === 0
                || JSON.parse(this.localItem.craftable))
                {
                    this.jsonErrorCraftable = null;
                    return true;
                }
            }
            catch(error) {
                // console.log("exception:" + error);
                this.jsonErrorCraftable = 'Invalid crafting recipe, malformed Json.';
            }
            return false;
        },
        closeDialog() {
            this.$emit('update:modelValue', false);
        },
        async saveAndClose() {
            if (!this.validateForSave()) return;

            const body = {
                itemHandle: this.localItem.itemHandle,
                name: this.localItem.name,
                description: this.localItem.description,
                weight: this.localItem.weight,
                maxStackSize: this.localItem.maxStackSize,
                bIsStackable: !!this.localItem.bIsStackable,
                bPlaceable: !!this.localItem.bPlaceable,
                rarity: this.localItem.rarity,
                itemQuality: this.localItem.itemQuality,
                itemType: this.localItem.itemType,
                bIsContainer: !!this.localItem.bIsContainer,
                containerMaxWeight: this.localItem.containerMaxWeight,
                containerMaxCount: this.localItem.containerMaxCount,
                icon: this.localItem.icon,
                mesh: this.localItem.mesh,
                visibility: this.localItem.visibility,
                craftable: !this.localItem.craftable ? null : JSON.parse(this.localItem.craftable),
                itemStatistics: !this.localItem.itemStatistics ? null : JSON.parse(this.localItem.itemStatistics),
                sourcecode: this.localItem.sourcecode
            };
            const token = localStorage.getItem('Auth');
            this.isBusy = true;

            try {
                const itemResponse = await fetch(`${process.env.VUE_APP_STONECREEK_BACKEND}/api/v2/item`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(body)
                });

                if (!itemResponse.ok) {
                    const json = await itemResponse.json();
                    this.errorMessage = json.error || 'Unknown error occurred.';
                    return;
                }

                if (this.localItem.IconFile?.base64) {
                    const iconResponse = await fetch(`${process.env.VUE_APP_STONECREEK_BACKEND}/api/v2/item/icon`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            iconHandle: this.localItem.itemHandle,
                            iconData: this.localItem.IconFile.base64,
                        })
                    });

                    if (!iconResponse.ok) {
                        const json = await iconResponse.json();
                        this.errorMessage = json.error || 'Failed to save icon.';
                        return;
                    }
                } else if (this.localItem.iconData) {
                    const iconResponse = await fetch(
                        `${process.env.VUE_APP_STONECREEK_BACKEND}/api/v2/item/icon/${this.localItem.itemHandle}`,
                        {
                            method: 'DELETE',
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );

                    if (!iconResponse.ok) {
                        const json = await iconResponse.json();
                        this.errorMessage = json.error || 'Failed to remove icon.';
                        return;
                    }
                }

                this.errorMessage = '';
                this.$emit('update:modelValue', false);
                this.$emit('request-reload');
            } finally {
                this.isBusy = false;
            }
        },
    },
};
</script>
